import { createFileRoute } from "@tanstack/react-router";

import { PageHeader } from "@/components/shared/page-help";
import { Card, CardContent } from "@/components/ui/card";
import { useExternalTestsOverview } from "@/lib/api/external-tests";

import { ExternalTestsGuideDashboard } from "./external-tests";

export const Route = createFileRoute("/external-tests-guide")({
	component: ExternalTestsGuidePage,
});

function ExternalTestsGuidePage() {
	const overview = useExternalTestsOverview();

	if (overview.isLoading) {
		return (
			<div className="mx-auto flex max-w-7xl flex-col gap-5">
				<PageHeader
					moduleId="EXT-T"
					title="外挂测试说明"
					description="解释 tau2 retail 外挂测试的能力范围、评价标准、任务集、隔离策略和回流边界。"
				/>
				<Card>
					<CardContent className="p-6 text-sm text-text-secondary">
						正在读取外挂测试说明...
					</CardContent>
				</Card>
			</div>
		);
	}

	if (overview.isError || !overview.data) {
		return (
			<div className="mx-auto flex max-w-7xl flex-col gap-5">
				<PageHeader
					moduleId="EXT-T"
					title="外挂测试说明"
					description="解释 tau2 retail 外挂测试的能力范围、评价标准、任务集、隔离策略和回流边界。"
				/>
				<Card>
					<CardContent className="p-6 text-sm text-brand-danger">
						外挂测试说明读取失败，请确认 Admin API 可用。
					</CardContent>
				</Card>
			</div>
		);
	}

	return <ExternalTestsGuideDashboard data={overview.data} />;
}
